import pathfinder from '@fiverr-private/pathfinder';
import { getDefaultLocaleValue } from '../../../../shared/utils';
import { PATHS, PATHFINDER } from '../../constants';

export const getStaticPagePath = ({ categoryId, id, nestedSubCategoryId, filterId }, source) => {

    if (!(categoryId && id && filterId)) {
        return PATHS.ROOT;
    }

    if (isNaN(parseInt(categoryId, 10)) || isNaN(parseInt(id, 10)) || (nestedSubCategoryId && (parseInt(nestedSubCategoryId, 10)))) {
        return PATHS.ROOT;
    }

    const categorySlug = getDefaultLocaleValue(`categories.category_${categoryId}.cached_slug`);
    const subCategorySlug = getDefaultLocaleValue(`sub_categories.sub_category_${id}.cached_slug`);

    let params = {
        category_id: categorySlug,
        id: subCategorySlug,
        filters_uid: filterId
    };
    const options = { query: { source } };

    if (nestedSubCategoryId) {
        const nestedSubCategorySlug = getDefaultLocaleValue(`sub_categories.sub_category_${id}.nested_sub_cat_${nestedSubCategoryId}.cached_slug`);

        params = {
            ...params,
            nested_sub_category_id: nestedSubCategorySlug
        };

        return pathfinder(PATHFINDER.NESTED_SUB_CATEGORY_STATIC_PAGE, params, options);
    }

    return pathfinder(PATHFINDER.SUB_CATEGORY_STATIC_PAGE, params, options);
};
